export default {
  'title.management.system': 'Tender',
  'menu.Home': 'Home',
  'menu.ContentList': 'Content List',
  'menu.ContentDetail': 'Content Details',
  'menu.ContentManagement': 'Content Management',
  'menu.NewContent': 'New Content',
  'menu.EditContent': 'Edit Content',
  'menu.BannerManagement': 'Banner Management',
  'menu.AuthorityManagement': 'Authority Management',
  'menu.AuthorityManagement.RoleManagement': 'Role Management',
  'menu.AuthorityManagement.NewRloe': 'New Role',
  'menu.AuthorityManagement.EditRloe': 'Edit Role',
  'menu.ViewContent': 'Content Detail',
  'menu.AuthorityManagement.UserManagement': 'User Management',
  'menu.MyFavourites': 'My Favourites',
  'menu.roleManagement': '角色管理',
  'menu.announcement': '公告列表',
  'menu.announcementDetail': '公告详情'
};
